import { useState } from "react";
import { Dialog } from "../Dialog";
import { Padder, SimpleContainer, SimplePageTemplate } from "./SimpleElements"
import { useUser } from "../../../biz/hooks/entities/useUser";
import { useTranslation } from 'react-i18next';

export const SimpleCampaigns = () => {

    const { t } = useTranslation();


    return (
        <SimplePageTemplate>
            <h1>
                {t("menu_campaigns")}
            </h1>

            <Padder heightPx={128} />
        </SimplePageTemplate>
    )
}